import { DeployedEnv } from '@typesApp/Config'
import { config } from '@config/config'
import { redactForLogging } from '@utils/logRedaction'

const sanitize = (args: unknown[]): unknown[] => {
  return args.map(arg => redactForLogging(arg))
}

const shouldLogVerbose = (): boolean => {
  return config.getDeployedEnv() !== DeployedEnv.PROD
}

export const logger = {
  debug: (...args: unknown[]): void => {
    if (shouldLogVerbose()) {
      console.debug(...sanitize(args))
    }
  },
  info: (...args: unknown[]): void => {
    if (shouldLogVerbose()) {
      console.info(...sanitize(args))
    }
  },
  warn: (...args: unknown[]): void => {
    console.warn(...sanitize(args))
  },
  error: (...args: unknown[]): void => {
    console.error(...sanitize(args))
  },
}
